<template>
  <div class="modal-body">
    <el-page-header @back="goBack" content="报表中心"></el-page-header>
    <div class="modal-body-scroll">

      <!--      -->
      <div class="titleBox">
        <span class="title">培训人次统计</span>
      </div>

      <div class="list">
        <div class="dis_style" @click="()=>{this.$router.push({ path: '/TrainPeopleReport'})}">
        <img class="logo_style" src="../../assets/imgs/report/332.png" />
        <span class="font_style">学院</span>
        </div>
        <div class="dis_style" @click="()=>{this.$router.push({ path: '/TrainBusinessReport'})}">
        <img class="logo_style" src="../../assets/imgs/report/331.png" />
        <span class="font_style">事业部</span>
        </div>
      </div>

      <!--      -->
      <div class="titleBox">
        <span class="title">培训成绩统计</span>
      </div>
      <div class="list">
       
        <div class="dis_style" @click="()=>{this.$router.push({ path: '/TrainScoreReport'})}">
        <img class="logo_style" src="../../assets/imgs/report/328.png" />
        <span class="font_style">成绩分布汇总</span>
        </div>
        <div class="dis_style" @click="()=>{this.$router.push({ path: '/PassRate'})}">
        <img class="logo_style" src="../../assets/imgs/report/327.png" />
        <span class="font_style">合格率汇总</span>
        </div>
        <div class="dis_style"  @click="()=>{this.$router.push({ path: '/PassBusiness'})}">
        <img class="logo_style" src="../../assets/imgs/report/326.png"/>
        <span class="font_style">事业部合格率</span>
        </div>
      </div>

      <div class="titleBox">
        <span class="title">工作量汇总</span>
      </div>

      <div class="list">
        <div class="dis_style"  @click="()=>{this.$router.push({ path: '/workSummary'})}">
        <img class="logo_style" src="../../assets/imgs/report/325.png"/>
        <span class="font_style">人员汇总</span>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import {getBaseUrl,} from "../../api/api";

export default {

  data() {
    return {
      baseUrl: getBaseUrl(),

    };
  },
  mounted() {
    window.getToken = (e) => {
      this.getToken(e)
    }
  },
  methods: {
    getToken(token) {
      window.sessionStorage.setItem("jwt-token", token);
      this.token = token;
      // this.getInfo(this.LearnerName);
    },

    goBack() {
      flutter_page_back.postMessage(this.fid + "");
    },

  },
  watch: {}
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;

}

.modal-body {
  overflow: hidden;
  height: 100%;
  padding: 0;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB",
  "\5B8B\4F53", "Microsoft Yahei", sans-serif;
}

.modal-body-scroll {
  overflow: auto;
  height: 100%;
  background-color: #f5f5f5;
}

.titleBox {
  height: 40px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  align-items: center;
}

.title {
  margin-left: 6px;
  color: #999999;
  font-size: 15px;
}

.list {
  display: flex;
  flex-direction: row;
  text-align: center;

  // justify-content: space-around;
}


.el-page-header {
  height: 80px;
  background: rgb(32, 148, 244);
  // display: flex;
  align-items: flex-end;
  color: #fff;
  padding: 0 10px 10px;
  box-sizing: border-box;
}

/deep/ .el-page-header__content {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  // margin-left: 16%;
  width: calc(100% - 188px);
  text-align: center;
}

/deep/ .el-page-header__left::after {
  display: none;
}
.dis_style{
  height: 110px;
  padding-right: 10px;
  padding-left: 25px;
  text-align: center;
}
.logo_style{
  width: 80px;
  height: 80px;
}
.font_style{
  position: absolute;
    text-align: center;
  align-content: center;
  width: 100px;
  padding-top: 90px;
  margin-left: -95px;
  // float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/report/ReportHome.vue